<template>
  <b-col class="pl-0 pr-0">
    <b-card
      :img-src="organization.map_image_light"
      no-body
      class="card-developer-meetup cursor-pointer buttons-effect card-branches"
      @click="goToOrganization"
    >
      <b-card-body class="card-body-branches">
        <!-- metting header -->
        <div class="meetup-header d-flex">
          <div class="my-auto text-left">
            <b-card-title class="title-branch">
              {{ organization.name }}
            </b-card-title>
          </div>
        </div>
        <!--/ metting header -->

        <!-- phone -->
        <b-media
          class="text-left"
          no-body
        >
          <b-media-aside class="mr-3">
            <b-avatar
              rounded
              class="avatar-icon"
              :style="`color: ${getWidgetSettings.main_color}`"
              size="34"
            >
              <b-icon
                icon="telephone"
              />
            </b-avatar>
          </b-media-aside>
          <b-media-body>
            <h6 class="mb-0 media-title">
              {{ organization.phone }}
            </h6>
            <small class="media-desc">{{ organization.email }}</small>
          </b-media-body>
        </b-media>
        <!-- address -->
        <b-media
          class="text-left"
          no-body
        >
          <b-media-aside class="mr-3">
            <b-avatar
              rounded
              class="avatar-icon"
              :style="`color: ${getWidgetSettings.main_color}`"
              size="34"
            >
              <b-icon
                icon="cursor"
              />
            </b-avatar>
          </b-media-aside>
          <b-media-body>
            <h6 class="mb-0 media-title">
              {{ organization.city }}
            </h6>
            <small class="media-desc">{{ organization.address }}</small>
          </b-media-body>
        </b-media>

        <!-- avatar group -->
        <b-avatar-group
          class="mt-2 pt-3 mb-0"
          size="36"
        >
            <b-avatar
              v-for="(workspace, i) in organization.workspace_by_org" :key="i"
              :src="workspace.avatar"
              :text="setAcronym(workspace.description)"
              :style="`color: ${getWidgetSettings.main_color}`"
              class="pull-up avatar-pull-up"
            ></b-avatar>
        </b-avatar-group>

      </b-card-body>
    </b-card>
  </b-col>
</template>

<script>
import {
  BCol, BCard, BCardTitle, BIcon, BCardBody, BMedia, BMediaAside, BAvatar, BMediaBody,
  BAvatarGroup,
} from 'bootstrap-vue'
import { setAcronym } from '@/libs/utils'
import { mapGetters } from 'vuex'

export default {
  name: 'WidgetBranchOfficeCard',
  directives: {
  // 'b-tooltip': VBTooltip,
  },
  components: {
    BCol,
    BCard,
    BCardTitle,
    BIcon,
    BCardBody,
    BMedia,
    BAvatar,
    BMediaAside,
    BMediaBody,
    BAvatarGroup,
    // BBadge,
  },
  props: {
    organization: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      setAcronym,
    }
  },
  computed: mapGetters(['getWidgetSettings']),
  methods: {
    async goToOrganization() {
      this.$emit('setBranch', this.organization.id)
    },
  },
}
</script>

<style scoped>

</style>
